import React from 'react'
import PropTypes from 'prop-types'

// Use
import { useParams } from 'react-router-dom'

// Models
import TicketInfoModel from 'models/Ticket'

// Api
import { downloadTicketAttachment } from 'api/ticket'

// Services
import message from 'services/message'

// Helpers
import { resolveErrorMessage } from 'helpers'

// Components
import Text from 'ui/Text'
import Box from 'ui/Box'
import Row from 'ui/Row'
import Col from 'ui/Col'
import FileItem from 'ui/FileItem'
import Datalist from 'ui/DataList'

export const TicketInfo = ({ ticket }) => {
  const data = [
    {
      id: 'ticketNo',
      label: 'Ticket no.:',
      value: ticket.ticketNo,
    },
    {
      id: 'dateRaised',
      label: 'Date raised:',
      value: ticket.createdAt,
    },
    {
      id: 'category',
      label: 'Issue category:',
      value: ticket.category,
    },
    {
      id: 'type',
      label: 'Issue type:',
      value: ticket.type,
      break: true,
    },
    {
      id: 'lessorName',
      label: 'Lessor name:',
      value: ticket.lessorName,
    },
    {
      id: 'vendorCode',
      label: 'Vendor code:',
      value: ticket.vendorCode,
    },
    {
      id: 'companyCode',
      label: 'Company code:',
      value: ticket.companyCode,
    },
    {
      id: 'contractNo',
      label: 'Contract no.:',
      value: ticket.contractNo,
    },
  ]
  const { id } = useParams()

  const onDownloadFile = async (name, setLoading) => {
    try {
      setLoading(true)
      // Call api
      await downloadTicketAttachment({ name, id })
    } catch (error) {
      message.error(await resolveErrorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Datalist data={data} narrow={true} color="secondary" />

      <Text bold color="#000000" paddingBottom={5} paddingTop={10}>
        Message
      </Text>

      <Box style={{ padding: '20px' }}>
        <Text color="#000000" preline wordBreak>
          {ticket.content}
        </Text>
      </Box>

      {ticket.files.length > 0 && (
        <Row>
          <Col xs={12} md={7} lg={6}>
            <Text bold color="#000000" paddingBottom={10} paddingTop={30}>
              Attachment/s
            </Text>
            {ticket.files.map((file, index) => {
              return (
                <FileItem
                  key={index}
                  name={file.name}
                  status={file.status}
                  onDownload={onDownloadFile}
                />
              )
            })}
          </Col>
        </Row>
      )}
    </>
  )
}

TicketInfo.propTypes = {
  ticket: PropTypes.instanceOf(TicketInfoModel),
}

TicketInfo.defaultProps = {
  ticket: new TicketInfoModel(),
}

export default TicketInfo
